import { render, staticRenderFns } from "./ResultDetailInvestOutRight.vue?vue&type=template&id=6f01c440&scoped=true&"
import script from "./ResultDetailInvestOutRight.vue?vue&type=script&lang=js&"
export * from "./ResultDetailInvestOutRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f01c440",
  null
  
)

export default component.exports